module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_8011.6e18c453.png";